import { ApiGetRequest } from 'types';

export enum EEecsFeesStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export enum EEecsFeesPaymentType {
  MANUAL = 'manual',
  STRIPE = 'stripe',
  DIGITAL = 'digital',
}

export enum EEecsFeesType {
  CERTIFICATE = 'certificate',
  PACKAGE = 'package',
}

export interface IEecsFee {
  id: string;
  fee: number;
  status: EEecsFeesStatus;
  payment_type: EEecsFeesPaymentType;
  seller_company: { id: number | null; name: string };
  buyer_company: { id: number | null; name: string };
  transaction_id: string;
  transaction_date: string;
  need_confirm_payment_by_main: boolean | null;
  main_company_uuid: string | null;
  type: EEecsFeesType;
}

export interface FetchEecsFeesPayload extends ApiGetRequest {
  filter_by_type: EEecsFeesType;
  filter_by_payment_type?: string | null;
  filter_by_status?: string | null;
  filter_by_transaction_start_date?: number | null;
  filter_by_transaction_end_date?: number | null;
  filter_by_counter_party_company_id?: number | null;
}
